module.exports = __webpack_public_path__ + "images/assets/cf9c1efde896df3f8edb4352f29a8490.svg";